import { Spin, Row, Col, Space, message, Alert, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ButtonItem,
  SwitchItem,
  dineroDisabledMask,
  round10Decimals,
} from "../../../../Components/Items";
import {
  FilePdfOutlined,
  ArrowLeftOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
  FileTextOutlined,
  UserOutlined,
  TeamOutlined,
  TagsOutlined,
  ClockCircleOutlined,
  InboxOutlined,
  NodeIndexOutlined,
  DollarOutlined,
  AppstoreOutlined,
  DownOutlined,
  RightOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import moment from "moment";
import "moment/locale/es";
import ModalMovimientoInventarioPdf from "../ModalMovimientoInventarioPdf/ModalMovimientoInventarioPdf";
import { decodeId } from "../../../../Components/idEncoder";

moment.locale("es");

const TIPOS_MOVIMIENTO = {
  101: { label: "Entrada por compra", color: "#10b981" },
  102: { label: "Reversa entrada", color: "#f59e0b" },
  103: { label: "Entrada por cambio de insumo", color: "#14b8a6" },
  201: { label: "Salida a centro de costos", color: "#ef4444" },
  261: { label: "Consumo a producción", color: "#8b5cf6" },
  301: { label: "Transferencia entre almacenes", color: "#3b82f6" },
  311: { label: "Cambio ubicación", color: "#06b6d4" },
  601: { label: "Salida por venta", color: "#ec4899" },
  602: { label: "Salida por cambio de insumo", color: "#a855f7" },
  651: { label: "Salida devolución", color: "#f97316" },
  701: { label: "Ajuste positivo inventario", color: "#22c55e" },
  702: { label: "Ajuste negativo inventario", color: "#dc2626" },
};

const Card = ({ title, icon, children, style, accent = "#00BFD6" }) => (
  <div
    style={{
      background: "white",
      border: "1px solid #e2e8f0",
      borderRadius: 10,
      overflow: "hidden",
      ...style,
    }}
  >
    {title && (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "10px 16px",
          background: "#f8fafc",
          borderBottom: "1px solid #e2e8f0",
        }}
      >
        {icon && (
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 24,
              height: 24,
              borderRadius: 6,
              background: `${accent}15`,
              color: accent,
            }}
          >
            {icon}
          </span>
        )}
        <span
          style={{
            fontSize: 13,
            fontWeight: 600,
            color: "#0f172a",
            letterSpacing: 0.2,
          }}
        >
          {title}
        </span>
      </div>
    )}
    <div style={{ padding: 16 }}>{children}</div>
  </div>
);

const Field = ({ label, children, mono }) => (
  <div style={{ marginBottom: 14 }}>
    <div
      style={{
        fontSize: 10.5,
        color: "#64748b",
        textTransform: "uppercase",
        letterSpacing: 0.5,
        fontWeight: 600,
        marginBottom: 3,
      }}
    >
      {label}
    </div>
    <div
      style={{
        fontSize: 14,
        color: "#0f172a",
        fontWeight: 500,
        fontFamily: mono
          ? "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace"
          : undefined,
      }}
    >
      {children || <span style={{ color: "#cbd5e1" }}>—</span>}
    </div>
  </div>
);

const PillES = ({ esSalida }) =>
  esSalida ? (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        padding: "4px 12px",
        borderRadius: 999,
        background: "#fee2e2",
        color: "#b91c1c",
        fontWeight: 600,
        fontSize: 12,
        border: "1px solid #fecaca",
      }}
    >
      <ArrowUpOutlined />
      Salida
    </span>
  ) : (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        padding: "4px 12px",
        borderRadius: 999,
        background: "#dcfce7",
        color: "#15803d",
        fontWeight: 600,
        fontSize: 12,
        border: "1px solid #bbf7d0",
      }}
    >
      <ArrowDownOutlined />
      Entrada
    </span>
  );

class VerMovimientoInventario extends Component {
  state = {
    loading: false,
    movimiento: null,
    modalPdfVisible: false,
    detallesAbierto: false,
    mostrarCostos: false,
  };

  componentDidMount() {
    this.consultar();
  }

  getMovimientoId() {
    const encoded = this.props.match?.params?.id;
    if (!encoded) return null;
    return decodeId(String(encoded));
  }

  consultar() {
    const id = this.getMovimientoId();
    if (!id) {
      message.error("No se recibió el id del movimiento");
      return;
    }
    this.setState({ loading: true });
    axios
      .post(
        "movimientosInventario/selectMovimientoInventario",
        { movimientoId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ movimiento: res.data.movimiento, loading: false });
        } else {
          message.error("No se encontró el movimiento");
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        message.error("Error al consultar el movimiento");
        this.setState({ loading: false });
      });
  }

  atras = () => {
    this.props.history.goBack();
  };

  togglePdf = () => {
    this.setState({ modalPdfVisible: !this.state.modalPdfVisible });
  };

  renderContraparte() {
    const m = this.state.movimiento;
    if (!m) return null;
    if (m.cliente) {
      const c = m.cliente;
      const nombre = c.razonSocial
        ? c.razonSocial
        : `${c.nombre || ""} ${c.apellidoPaterno || ""} ${c.apellidoMaterno || ""}`.trim();
      return (
        <Card title="Cliente" icon={<UserOutlined />} accent="#ec4899">
          <Field label="Nombre / Razón Social">{nombre}</Field>
        </Card>
      );
    }
    if (m.proveedor) {
      const p = m.proveedor;
      const nombre = p.razonSocial
        ? p.razonSocial
        : `${p.nombre || ""} ${p.apellidoPaterno || ""} ${p.apellidoMaterno || ""}`.trim();
      return (
        <Card title="Proveedor" icon={<TeamOutlined />} accent="#8b5cf6">
          <Field label="Nombre / Razón Social">{nombre}</Field>
        </Card>
      );
    }
    return null;
  }

  render() {
    const { movimiento, loading } = this.state;
    const puedeVerCostos = !!this.props.permisoMostrarCostosMovimientosInventario;
    const costosActivos = puedeVerCostos && this.state.mostrarCostos;
    const folio = `${movimiento?.serie ? movimiento.serie + " - " : ""}${movimiento?.folio || ""}` || movimiento?.serieNumero || "-";
    const folioTipo =
      movimiento?.serieTipo || movimiento?.folioTipo
        ? `${movimiento?.serieTipo ? movimiento.serieTipo + " - " : ""}${movimiento?.folioTipo || ""}`
        : null;
    const tipoCfg = movimiento ? TIPOS_MOVIMIENTO[movimiento.tipoMovimiento] : null;
    const tipoDesc =
      movimiento?.descripcionTipoMovimiento ||
      tipoCfg?.label ||
      "-";
    const tipoColor = tipoCfg?.color || "#64748b";

    const tieneTraza =
      movimiento &&
      Array.isArray(movimiento.insumos) &&
      movimiento.insumos.some(
        (i) => Array.isArray(i.trazabilidad) && i.trazabilidad.length > 0
      );

    return (
      <>
        <Spin spinning={loading}>
          {movimiento && (
            <div style={{ paddingBottom: 20 }}>
              {/* Banner cancelado */}
              {movimiento.estado === 0 && (
                <Alert
                  type="error"
                  showIcon
                  style={{ marginBottom: 12, borderRadius: 8 }}
                  message="Movimiento cancelado"
                  description={
                    movimiento.cancelacion
                      ? `${
                          movimiento.cancelacion.motivo
                            ? `Motivo: ${movimiento.cancelacion.motivo}. `
                            : ""
                        }${
                          movimiento.cancelacion.fecha
                            ? `Cancelado el ${moment(
                                movimiento.cancelacion.fecha
                              ).format("DD/MM/YYYY HH:mm")}`
                            : ""
                        }${
                          movimiento.cancelacion.usuario
                            ? ` por ${movimiento.cancelacion.usuario.nombre || ""} ${
                                movimiento.cancelacion.usuario.apellidoPaterno || ""
                              }`
                            : ""
                        }`
                      : "Este movimiento ya no afecta el inventario."
                  }
                />
              )}

              {/* Hero — mismo formato que el PageHeader de la lista */}
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #00BFD6 0%, #0891b2 100%)",
                  borderRadius: 6,
                  padding: "16px 24px",
                  marginBottom: 10,
                  color: "white",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: -40,
                    right: -40,
                    width: 160,
                    height: 160,
                    background: `radial-gradient(circle, ${tipoColor}44 0%, transparent 70%)`,
                  }}
                />

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 18,
                    position: "relative",
                    flexWrap: "wrap",
                  }}
                >
                  <button
                    onClick={this.atras}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 34,
                      height: 34,
                      borderRadius: 8,
                      background: "rgba(255, 255, 255, 0.08)",
                      border: "1px solid rgba(255, 255, 255, 0.15)",
                      color: "white",
                      cursor: "pointer",
                      transition: "all 0.15s",
                      flexShrink: 0,
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background =
                        "rgba(255, 255, 255, 0.16)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background =
                        "rgba(255, 255, 255, 0.08)";
                    }}
                  >
                    <ArrowLeftOutlined style={{ fontSize: 14 }} />
                  </button>

                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 34,
                      height: 34,
                      borderRadius: 8,
                      background: `linear-gradient(135deg, ${tipoColor} 0%, ${tipoColor}cc 100%)`,
                      color: "white",
                      boxShadow: `0 3px 10px ${tipoColor}55`,
                      flexShrink: 0,
                    }}
                  >
                    <FileTextOutlined style={{ fontSize: 16 }} />
                  </span>

                  {/* Folio */}
                  <div style={{ lineHeight: 1.2 }}>
                    <div
                      style={{
                        fontSize: 10,
                        color: "rgba(255, 255, 255, 0.75)",
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                        fontWeight: 600,
                        marginBottom: 1,
                      }}
                    >
                      Folio
                    </div>
                    <div
                      style={{
                        fontSize: 11,
                        fontWeight: 500,
                        color: "rgba(255, 255, 255, 0.55)",
                        fontFamily:
                          "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
                        letterSpacing: 0.3,
                      }}
                    >
                      {folio || "-"}
                    </div>
                    {folioTipo && (
                      <div
                        style={{
                          fontSize: 19,
                          fontWeight: 700,
                          fontFamily:
                            "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
                          letterSpacing: 0.4,
                          background: "rgba(255,255,255,0.12)",
                          border: "1px solid rgba(255,255,255,0.25)",
                          padding: "2px 8px",
                          borderRadius: 6,
                          marginTop: 3,
                          display: "inline-block",
                        }}
                      >
                        {folioTipo}
                      </div>
                    )}
                  </div>

                  {/* Separador */}
                  <div
                    style={{
                      width: 1,
                      height: 36,
                      background: "rgba(255,255,255,0.1)",
                    }}
                  />

                  {/* Tipo */}
                  <div style={{ lineHeight: 1.2, minWidth: 0, flex: 1 }}>
                    <div
                      style={{
                        fontSize: 10,
                        color: "rgba(255, 255, 255, 0.75)",
                        textTransform: "uppercase",
                        letterSpacing: 0.5,
                        fontWeight: 600,
                        marginBottom: 2,
                      }}
                    >
                      Tipo
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          padding: "2px 8px",
                          borderRadius: 5,
                          background: tipoColor,
                          color: "white",
                          fontWeight: 700,
                          fontSize: 12,
                          fontFamily:
                            "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
                        }}
                      >
                        {movimiento.tipoMovimiento}
                      </span>
                      <span style={{ fontSize: 14, fontWeight: 500 }}>
                        {tipoDesc}
                      </span>
                    </div>
                  </div>

                  {/* Fecha */}
                  <div
                    style={{
                      fontSize: 12,
                      color: "#cbd5e1",
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                    }}
                  >
                    <ClockCircleOutlined style={{ fontSize: 12 }} />
                    {movimiento.fecha
                      ? moment(movimiento.fecha).format("DD MMM YYYY · HH:mm")
                      : "-"}
                  </div>

                  {/* Pills */}
                  <PillES esSalida={movimiento.esSalida} />
                  {movimiento.estado === 0 ? (
                    <span
                      style={{
                        display: "inline-block",
                        padding: "4px 11px",
                        borderRadius: 999,
                        background: "rgba(239, 68, 68, 0.15)",
                        color: "#fca5a5",
                        fontSize: 12,
                        fontWeight: 600,
                        border: "1px solid rgba(239, 68, 68, 0.3)",
                      }}
                    >
                      Cancelado
                    </span>
                  ) : (
                    <span
                      style={{
                        display: "inline-block",
                        padding: "4px 11px",
                        borderRadius: 999,
                        background: "rgba(34, 197, 94, 0.15)",
                        color: "#86efac",
                        fontSize: 12,
                        fontWeight: 600,
                        border: "1px solid rgba(34, 197, 94, 0.3)",
                      }}
                    >
                      Activo
                    </span>
                  )}

                  {/* Acciones */}
                  <Space size={6} style={{ marginLeft: "auto" }}>
                    <Tooltip
                      title={
                        puedeVerCostos
                          ? "Mostrar costos en detalle y PDF"
                          : "No tienes permiso para ver costos"
                      }
                      overlayInnerStyle={{
                        fontSize: "10px",
                        padding: "1px 5px",
                        minHeight: "auto",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 6,
                          marginRight: 4,
                        }}
                      >
                        <span style={{ fontSize: 12, color: "white" }}>
                          Mostrar costos
                        </span>
                        <SwitchItem
                          checked={costosActivos}
                          disabled={!puedeVerCostos}
                          onChange={(checked) =>
                            this.setState({ mostrarCostos: checked })
                          }
                        />
                      </span>
                    </Tooltip>
                    <ButtonItem
                      lila
                      icon={<FilePdfOutlined />}
                      onClick={this.togglePdf}
                      disabled={!movimiento}
                    >
                      Ver PDF
                    </ButtonItem>
                    <ButtonItem onClick={this.atras}>Regresar</ButtonItem>
                  </Space>
                </div>
              </div>

              {/* Toggle detalles */}
              <div
                onClick={() =>
                  this.setState({ detallesAbierto: !this.state.detallesAbierto })
                }
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "10px 16px",
                  background: "white",
                  border: "1px solid #e2e8f0",
                  borderRadius: 10,
                  cursor: "pointer",
                  marginBottom: 12,
                  userSelect: "none",
                  transition: "all 0.2s",
                }}
              >
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 24,
                    height: 24,
                    borderRadius: 6,
                    background: "#00BFD615",
                    color: "#00BFD6",
                  }}
                >
                  <InfoCircleOutlined />
                </span>
                <span
                  style={{
                    flex: 1,
                    fontSize: 13,
                    fontWeight: 600,
                    color: "#0f172a",
                  }}
                >
                  Detalles del movimiento
                </span>
                <span
                  style={{
                    fontSize: 11,
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  {this.state.detallesAbierto ? "Ocultar" : "Mostrar"}
                </span>
                {this.state.detallesAbierto ? (
                  <DownOutlined style={{ color: "#64748b", fontSize: 12 }} />
                ) : (
                  <RightOutlined style={{ color: "#64748b", fontSize: 12 }} />
                )}
              </div>

              {this.state.detallesAbierto && (
              <>
              {/* Totales destacados */}
              <Row gutter={12} style={{ marginBottom: 12 }}>
                <Col xs={24} md={costosActivos ? 12 : 24}>
                  <div
                    style={{
                      background: "white",
                      border: "1px solid #e2e8f0",
                      borderRadius: 10,
                      padding: "14px 18px",
                      display: "flex",
                      alignItems: "center",
                      gap: 14,
                    }}
                  >
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 42,
                        height: 42,
                        borderRadius: 10,
                        background: "#dbeafe",
                        color: "#1e40af",
                      }}
                    >
                      <AppstoreOutlined style={{ fontSize: 18 }} />
                    </span>
                    <div>
                      <div
                        style={{
                          fontSize: 11,
                          color: "#64748b",
                          textTransform: "uppercase",
                          letterSpacing: 0.5,
                          fontWeight: 600,
                        }}
                      >
                        Cantidad Total
                      </div>
                      <div
                        style={{
                          fontSize: 22,
                          fontWeight: 700,
                          color: "#0f172a",
                          fontVariantNumeric: "tabular-nums",
                          lineHeight: 1.1,
                        }}
                      >
                        {round10Decimals(movimiento.cantidadTotal || 0)}
                      </div>
                    </div>
                  </div>
                </Col>
                {costosActivos && (
                  <Col xs={24} md={12}>
                    <div
                      style={{
                        background: "white",
                        border: "1px solid #e2e8f0",
                        borderRadius: 10,
                        padding: "14px 18px",
                        display: "flex",
                        alignItems: "center",
                        gap: 14,
                      }}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 42,
                          height: 42,
                          borderRadius: 10,
                          background: "#dcfce7",
                          color: "#15803d",
                        }}
                      >
                        <DollarOutlined style={{ fontSize: 18 }} />
                      </span>
                      <div>
                        <div
                          style={{
                            fontSize: 11,
                            color: "#64748b",
                            textTransform: "uppercase",
                            letterSpacing: 0.5,
                            fontWeight: 600,
                          }}
                        >
                          Costo Total
                        </div>
                        <div
                          style={{
                            fontSize: 22,
                            fontWeight: 700,
                            color: "#0f172a",
                            fontVariantNumeric: "tabular-nums",
                            lineHeight: 1.1,
                          }}
                        >
                          {dineroDisabledMask(movimiento.costoTotal || 0)}
                        </div>
                      </div>
                    </div>
                  </Col>
                )}
              </Row>

              {/* Cards de información */}
              <Row gutter={12} style={{ marginBottom: 12 }}>
                <Col span={24}>
                  <Card
                    title="Documento Origen"
                    icon={<FileTextOutlined />}
                    accent="#1e40af"
                  >
                    <Row gutter={16}>
                      <Col xs={24} md={12}>
                        <Field label="Tipo">
                          {movimiento.documentoOrigenTipo ? (
                            <span
                              style={{
                                display: "inline-block",
                                fontSize: 12,
                                fontWeight: 700,
                                color: "#1e40af",
                                background: "#dbeafe",
                                padding: "2px 10px",
                                borderRadius: 4,
                              }}
                            >
                              {movimiento.documentoOrigenTipo}
                            </span>
                          ) : null}
                        </Field>
                      </Col>
                      <Col xs={24} md={12}>
                        <Field label="Serie / Folio" mono>
                          {movimiento.documentoOrigenSerieFolio}
                        </Field>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>

              {(movimiento.cliente || movimiento.proveedor) && (
                <Row gutter={12} style={{ marginBottom: 12 }}>
                  <Col xs={24} md={12}>
                    {this.renderContraparte()}
                  </Col>
                  <Col xs={24} md={12}>
                    <Card
                      title="Detalle"
                      icon={<TagsOutlined />}
                      accent="#0891b2"
                    >
                      <Field label="Concepto">{movimiento.concepto}</Field>
                      <Field label="Referencia">{movimiento.referencia}</Field>
                    </Card>
                  </Col>
                </Row>
              )}

              {!movimiento.cliente &&
                !movimiento.proveedor &&
                (movimiento.concepto || movimiento.referencia) && (
                  <Row gutter={12} style={{ marginBottom: 12 }}>
                    <Col span={24}>
                      <Card
                        title="Detalle"
                        icon={<TagsOutlined />}
                        accent="#0891b2"
                      >
                        <Row gutter={16}>
                          <Col xs={24} md={12}>
                            <Field label="Concepto">{movimiento.concepto}</Field>
                          </Col>
                          <Col xs={24} md={12}>
                            <Field label="Referencia">
                              {movimiento.referencia}
                            </Field>
                          </Col>
                        </Row>
                      </Card>
                    </Col>
                  </Row>
                )}

              {movimiento.observaciones && (
                <div style={{ marginBottom: 12 }}>
                  <Card
                    title="Observaciones"
                    icon={<FileTextOutlined />}
                    accent="#f59e0b"
                  >
                    <div
                      style={{
                        fontSize: 13,
                        color: "#475569",
                        lineHeight: 1.5,
                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {movimiento.observaciones}
                    </div>
                  </Card>
                </div>
              )}

              </>
              )}

              {/* Tabla de insumos */}
              <Card
                title={`Insumos (${(movimiento.insumos || []).length})`}
                icon={<InboxOutlined />}
                accent="#00BFD6"
                style={{ marginBottom: 12 }}
              >
                <div style={{ overflowX: "auto" }}>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "separate",
                      borderSpacing: 0,
                      fontSize: 12.5,
                    }}
                  >
                    <thead>
                      <tr>
                        {(costosActivos
                          ? [
                              { t: "Clave", w: "9%", a: "left" },
                              { t: "Descripción", w: "23%", a: "left" },
                              { t: "Proyecto", w: "13%", a: "left" },
                              { t: "Cantidad", w: "9%", a: "right" },
                              { t: "Unidad", w: "7%", a: "center" },
                              { t: "Costo U.", w: "10%", a: "right" },
                              { t: "Costo Total", w: "10%", a: "right" },
                              { t: "Lote", w: "10%", a: "center" },
                              { t: "Caducidad", w: "9%", a: "center" },
                            ]
                          : [
                              { t: "Clave", w: "10%", a: "left" },
                              { t: "Descripción", w: "32%", a: "left" },
                              { t: "Proyecto", w: "16%", a: "left" },
                              { t: "Cantidad", w: "11%", a: "right" },
                              { t: "Unidad", w: "9%", a: "center" },
                              { t: "Lote", w: "11%", a: "center" },
                              { t: "Caducidad", w: "11%", a: "center" },
                            ]
                        ).map((h) => (
                          <th
                            key={h.t}
                            style={{
                              width: h.w,
                              textAlign: h.a,
                              padding: "10px 12px",
                              background: "#f8fafc",
                              borderBottom: "2px solid #e2e8f0",
                              fontSize: 10.5,
                              fontWeight: 700,
                              color: "#475569",
                              textTransform: "uppercase",
                              letterSpacing: 0.5,
                              position: "sticky",
                              top: 0,
                            }}
                          >
                            {h.t}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {(movimiento.insumos || []).map((item, idx) => {
                        const ins = item.insumo || {};
                        const cant = Number(item.cantidad) || 0;
                        const cu = Number(item.costoUnitario) || 0;
                        const ct =
                          item.costoTotal !== undefined &&
                          item.costoTotal !== null
                            ? Number(item.costoTotal)
                            : cu * cant;
                        const zebra = idx % 2 === 1 ? "#fafbfc" : "white";
                        return (
                          <tr key={idx} style={{ background: zebra }}>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #f1f5f9",
                                fontFamily:
                                  "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
                                fontSize: 11.5,
                                fontWeight: 600,
                                color: "#0f172a",
                              }}
                            >
                              {ins.clave || ins.codigo || "-"}
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #f1f5f9",
                                color: "#0f172a",
                              }}
                            >
                              {ins.descripcion || "-"}
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #f1f5f9",
                                fontSize: 11.5,
                                color: "#475569",
                              }}
                            >
                              {item.proyecto?.nombre ||
                                item.proyectoId?.nombre ||
                                item.proyectoNombre || (
                                  <span style={{ color: "#cbd5e1" }}>—</span>
                                )}
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #f1f5f9",
                                textAlign: "right",
                                fontVariantNumeric: "tabular-nums",
                                fontWeight: 600,
                                color: "#0f172a",
                              }}
                            >
                              {round10Decimals(cant)}
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #f1f5f9",
                                textAlign: "center",
                                color: "#64748b",
                              }}
                            >
                              {ins.unidad?.nombre || ins.unidadNombre || "-"}
                            </td>
                            {costosActivos && (
                              <>
                                <td
                                  style={{
                                    padding: "10px 12px",
                                    borderBottom: "1px solid #f1f5f9",
                                    textAlign: "right",
                                    fontVariantNumeric: "tabular-nums",
                                    color: "#475569",
                                  }}
                                >
                                  {dineroDisabledMask(cu)}
                                </td>
                                <td
                                  style={{
                                    padding: "10px 12px",
                                    borderBottom: "1px solid #f1f5f9",
                                    textAlign: "right",
                                    fontVariantNumeric: "tabular-nums",
                                    fontWeight: 600,
                                    color: "#0f172a",
                                  }}
                                >
                                  {dineroDisabledMask(ct)}
                                </td>
                              </>
                            )}
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #f1f5f9",
                                textAlign: "center",
                                fontFamily:
                                  "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
                                fontSize: 11.5,
                                color: "#475569",
                              }}
                            >
                              {item.lote ||
                                item.numero ||
                                item.numeroMarbete || (
                                  <span style={{ color: "#cbd5e1" }}>—</span>
                                )}
                            </td>
                            <td
                              style={{
                                padding: "10px 12px",
                                borderBottom: "1px solid #f1f5f9",
                                textAlign: "center",
                                color: "#475569",
                              }}
                            >
                              {item.caducidad ? (
                                moment(item.caducidad).format("DD/MM/YYYY")
                              ) : (
                                <span style={{ color: "#cbd5e1" }}>—</span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                      {(movimiento.insumos || []).length === 0 && (
                        <tr>
                          <td
                            colSpan={costosActivos ? 9 : 7}
                            style={{
                              padding: 24,
                              textAlign: "center",
                              color: "#94a3b8",
                            }}
                          >
                            No hay insumos en este movimiento
                          </td>
                        </tr>
                      )}
                    </tbody>
                    {(movimiento.insumos || []).length > 0 && (
                      <tfoot>
                        <tr>
                          <td
                            colSpan={3}
                            style={{
                              padding: "10px 12px",
                              fontWeight: 700,
                              color: "#475569",
                              background: "#f8fafc",
                              borderTop: "2px solid #e2e8f0",
                              textTransform: "uppercase",
                              fontSize: 11,
                              letterSpacing: 0.5,
                            }}
                          >
                            Totales
                          </td>
                          <td
                            style={{
                              padding: "10px 12px",
                              textAlign: "right",
                              fontVariantNumeric: "tabular-nums",
                              fontWeight: 700,
                              color: "#0f172a",
                              background: "#f8fafc",
                              borderTop: "2px solid #e2e8f0",
                            }}
                          >
                            {round10Decimals(movimiento.cantidadTotal || 0)}
                          </td>
                          {costosActivos ? (
                            <>
                              <td
                                colSpan={2}
                                style={{
                                  background: "#f8fafc",
                                  borderTop: "2px solid #e2e8f0",
                                }}
                              />
                              <td
                                style={{
                                  padding: "10px 12px",
                                  textAlign: "right",
                                  fontVariantNumeric: "tabular-nums",
                                  fontWeight: 700,
                                  color: "#0f172a",
                                  background: "#f8fafc",
                                  borderTop: "2px solid #e2e8f0",
                                }}
                              >
                                {dineroDisabledMask(movimiento.costoTotal || 0)}
                              </td>
                              <td
                                colSpan={2}
                                style={{
                                  background: "#f8fafc",
                                  borderTop: "2px solid #e2e8f0",
                                }}
                              />
                            </>
                          ) : (
                            <td
                              colSpan={3}
                              style={{
                                background: "#f8fafc",
                                borderTop: "2px solid #e2e8f0",
                              }}
                            />
                          )}
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>
              </Card>

              {/* Trazabilidad */}
              {tieneTraza && (
                <Card
                  title="Trazabilidad — capas afectadas"
                  icon={<NodeIndexOutlined />}
                  accent="#8b5cf6"
                  style={{ marginBottom: 12 }}
                >
                  <div style={{ overflowX: "auto" }}>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "separate",
                        borderSpacing: 0,
                        fontSize: 12.5,
                      }}
                    >
                      <thead>
                        <tr>
                          {(costosActivos
                            ? [
                                { t: "Insumo", w: "30%", a: "left" },
                                { t: "Lote / Marbete", w: "20%", a: "center" },
                                { t: "Caducidad", w: "15%", a: "center" },
                                { t: "Cantidad", w: "15%", a: "right" },
                                { t: "Costo U.", w: "20%", a: "right" },
                              ]
                            : [
                                { t: "Insumo", w: "40%", a: "left" },
                                { t: "Lote / Marbete", w: "25%", a: "center" },
                                { t: "Caducidad", w: "20%", a: "center" },
                                { t: "Cantidad", w: "15%", a: "right" },
                              ]
                          ).map((h) => (
                            <th
                              key={h.t}
                              style={{
                                width: h.w,
                                textAlign: h.a,
                                padding: "10px 12px",
                                background: "#faf5ff",
                                borderBottom: "2px solid #e9d5ff",
                                fontSize: 10.5,
                                fontWeight: 700,
                                color: "#6b21a8",
                                textTransform: "uppercase",
                                letterSpacing: 0.5,
                              }}
                            >
                              {h.t}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {(movimiento.insumos || []).flatMap((item, idx) => {
                          if (
                            !Array.isArray(item.trazabilidad) ||
                            item.trazabilidad.length === 0
                          )
                            return [];
                          const ins = item.insumo || {};
                          const claveDesc = `${ins.clave || ins.codigo || ""}${
                            ins.descripcion ? " - " + ins.descripcion : ""
                          }`;
                          return item.trazabilidad.map((t, j) => {
                            const zebra = j % 2 === 1 ? "#fafbfc" : "white";
                            return (
                              <tr key={`${idx}-${j}`} style={{ background: zebra }}>
                                <td
                                  style={{
                                    padding: "10px 12px",
                                    borderBottom: "1px solid #f1f5f9",
                                    color: "#0f172a",
                                  }}
                                >
                                  {claveDesc}
                                </td>
                                <td
                                  style={{
                                    padding: "10px 12px",
                                    borderBottom: "1px solid #f1f5f9",
                                    textAlign: "center",
                                    fontFamily:
                                      "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
                                    fontSize: 11.5,
                                    color: "#475569",
                                  }}
                                >
                                  {t.lote || t.numeroMarbete || "-"}
                                </td>
                                <td
                                  style={{
                                    padding: "10px 12px",
                                    borderBottom: "1px solid #f1f5f9",
                                    textAlign: "center",
                                    color: "#475569",
                                  }}
                                >
                                  {t.caducidad
                                    ? moment(t.caducidad).format("DD/MM/YYYY")
                                    : "-"}
                                </td>
                                <td
                                  style={{
                                    padding: "10px 12px",
                                    borderBottom: "1px solid #f1f5f9",
                                    textAlign: "right",
                                    fontVariantNumeric: "tabular-nums",
                                    fontWeight: 600,
                                    color: "#0f172a",
                                  }}
                                >
                                  {round10Decimals(t.cantidad || 0)}
                                </td>
                                {costosActivos && (
                                  <td
                                    style={{
                                      padding: "10px 12px",
                                      borderBottom: "1px solid #f1f5f9",
                                      textAlign: "right",
                                      fontVariantNumeric: "tabular-nums",
                                      color: "#475569",
                                    }}
                                  >
                                    {dineroDisabledMask(t.costoU || 0)}
                                  </td>
                                )}
                              </tr>
                            );
                          });
                        })}
                      </tbody>
                    </table>
                  </div>
                </Card>
              )}

              {/* Auditoría */}
              <Card
                title="Auditoría"
                icon={<ClockCircleOutlined />}
                accent="#64748b"
              >
                <Row gutter={16}>
                  <Col xs={24} md={8}>
                    <Field label="Capturó">
                      {movimiento.usuario
                        ? `${movimiento.usuario.nombre || ""} ${
                            movimiento.usuario.apellidoPaterno || ""
                          }`.trim()
                        : null}
                    </Field>
                  </Col>
                  <Col xs={24} md={8}>
                    <Field label="Creado">
                      {movimiento.createdAt
                        ? moment(movimiento.createdAt).format(
                            "DD/MM/YYYY HH:mm"
                          )
                        : null}
                    </Field>
                  </Col>
                  <Col xs={24} md={8}>
                    <Field label="Actualizado">
                      {movimiento.updatedAt
                        ? moment(movimiento.updatedAt).format(
                            "DD/MM/YYYY HH:mm"
                          )
                        : null}
                    </Field>
                  </Col>
                </Row>
              </Card>
            </div>
          )}
        </Spin>

        <ModalMovimientoInventarioPdf
          visible={this.state.modalPdfVisible}
          movimientoId={this.getMovimientoId()}
          movimientoFolio={folio}
          mostrarCostos={costosActivos}
          onCancel={this.togglePdf}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoMostrarCostosMovimientosInventario:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) =>
        valueTodos.permisoId.toString() === "69fe8f69d4eff74041f388f2"
    )?.activado,
});

export default connect(mapStateToProps)(VerMovimientoInventario);
